<template>
  <section class="news-container">
    <el-tabs
      v-model="activeTab"
      @tab-click="handleTab">
      <el-tab-pane
        v-for="(tab, index) in tabList"
        :key="index"
        :label="tab.label"
        :name="String(tab.name)"
      ></el-tab-pane>
    </el-tabs>
    <div class="content-container">
      <div class="filter-container">
        <div class="filter-list">
          <v-date-picker
            v-model="date"
            :format="'dd-MM-yyyy HH:mm:ss'"
            :valueFormat="'yyyy-MM-dd HH:mm:ss'"
            :default-time="['00:00:00', '23:59:59']"
            type="datetimerange"
            @change="filterData"/>
          <!--          <v-date-picker-->
          <!--            v-model="date"-->
          <!--            type="daterange"-->
          <!--            @change="filterData"></v-date-picker>-->
          <v-input
            v-model="coupon_code"
            class="margint-left"
            placeholder="Code"
            @keyEnter="filterData"
            @blur="filterData"></v-input>
        </div>
        <div>
          <v-button
            v-if="activeTab == '1'"
            type="primary"
            @click="onNewBanner">New Coupon</v-button>
          <v-button
            v-if="activeTab == '6'"
            type="primary"
            @click="onNewSMEBanner">New SME Coupon</v-button>
          <v-button
            v-if="activeTab == '7'"
            type="primary"
            @click="onNewBanner('alipay')">New Alipay Coupon</v-button>
        </div>
      </div>

      <div class="transparent">
        <el-table
          :data="couponsData"
          style="width: 100%"
          :header-row-class-name="headerClass"
          @row-click="handlerRowClick">
          <el-table-column
            label="Code"
          >
            <template slot-scope="scope">
              <p>{{scope.row.code}}</p>
              <p class="long-title">{{handlerTitle(scope.row.title)}}</p>
            </template>
          </el-table-column>
          <el-table-column
            label="Activated" >
            <template slot-scope="scope">
              <div class="flex-algin">
                <p>{{scope.row.status===1?'Active':'Inactive'}}</p>
                <p></p>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            prop="limited_save_times"
            label="Times Saved">
            <template slot-scope="scope">
              <div class="flex-algin">
                <p>{{scope.row.limited_save_times}}</p>
                <p></p>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="times_used"
            label="Times Used"
          >
            <template slot-scope="scope">
              <div class="flex-algin">
                <p>{{scope.row.times_used}}</p>
                <p></p>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="start_time"
            label="From"
          >
            <template slot-scope="scope">
              <p>
                {{handlerTime(scope.row.start_time)[0]}}
              </p>
              <p>
                {{handlerTime(scope.row.start_time)[1]}}
              </p>
            </template>
            <template >
            </template>
          </el-table-column>
          <el-table-column
            prop="end_time"
            label="To"
          >
            <template slot-scope="scope">
              <p>
                {{handlerTime(scope.row.end_time)[0]}}
              </p>
              <p>
                {{handlerTime(scope.row.end_time)[1]}}
              </p>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <v-pagination
      v-if="activeTab != '6'"
      :total="pageConfig.total"
      :current="pageConfig.currentPage"
      @currentChange="currentChange"
    />

  </section>
</template>
<script>
import {getCouponList,getSmeCouponList,getAlipayList} from '@/api/coupon'
import MixinOptions from '@/mixins/options'
import {mapActions,mapState} from 'vuex'

export default {
  name: 'CouponsContainer',
  mixins: [MixinOptions],
  props:{
    headerClass:{
      type:Function,
      default:()=>{
        return 'headerClass'
      }
    }
  },
  data() {
    return {
      pageConfig: {
        //  分頁配置
        size:20,
        currentPage: 1,
        total: 10
      },
      activeTab: '1',
      coupon_code:'',
      tabList: [
        {
          name: '1',
          label: 'Current Coupons'
        },
        {
          name: '2',
          label: 'Upcoming'
        },
        {
          name: '3',
          label: 'Past'
        },
        {
          name: '4',
          label: 'Active'
        },
        {
          name: '5',
          label: 'Inactive'
        },
        {
          name: '6',
          label: 'SME'
        },
        {
          name: '7',
          label: 'Alipay'
        },
      ],
      status:'',
      couponsData: [],
      date:''
    }
  },
  computed: {
    ...mapState('coupon', ['getActiveTab']),
  },
  watch: {
    property: {
      immediate: true,
      handler() {
        // if(this.activeTab == 6){
        //   this.network().getSmeCouponList()
        // }else if(this.activeTab == 7){
        //   this.network().getAlipayList()
        // }
        // else{
        //   this.network().getCouponList()
        // }
        // this.network().getNewsCategoriesList()
      }
    },
    getActiveTab:{
      immediate: true,
      handler(val){
        if(val && val != this.activeTab){
          this.activeTab = val
          this.handleTab()
        }
      }
    }
  },
  mounted(){
    this.handleTab()
  },
  methods: {
    ...mapActions('coupon', ['setActiveTab']),
    handlerTitle(title){
      return title['en-US']
    },
    handlerTime(time){
      return time = time?time.split(' '):['-','-']
    },
    filterData() {
      this.pageConfig.currentPage = 1
      if(this.activeTab!=6)
        this.network().getCouponList()
      else
        this.network().getSmeCouponList()
    },
    handleTab(){
      this.pageConfig.currentPage = 1
      this.setActiveTab(this.activeTab)
      if(this.activeTab == 6){
        this.network().getSmeCouponList()
      }else if(this.activeTab == 7){
        this.network().getAlipayList()
      }
      else{
        this.network().getCouponList()
      }
    },
    currentChange(page) {
      this.pageConfig.currentPage = page
      this.network().getCouponList()
    },
    handlerRowClick({ code,id }) {
      let path = this.activeTab!=6?'/administration/coupon/detail':'/administration/sme/coupon/detail'
      this.$router.push({
        path: path,
        query: {
          code: code,
          cid:id
        }
      })
    },
    onNewBanner(type) {
      this.$router.push({
        path: '/administration/coupon/detail',
        query:{
          type
        }
      })
    },
    onNewSMEBanner() {
      this.$router.push({
        path: '/administration/sme/coupon/detail'
      })
    },
    network() {
      return {
        getCouponList: async (params = {}) => {
          // status
          // 1-current 2-upcoming 3-past
          const { data } = await getCouponList({
            page: this.pageConfig.currentPage,
            size: this.pageConfig.size,
            type: this.activeTab == 7? 1 : Number(this.activeTab),
            start_time:this.date?this.date[0]:'',
            end_time:this.date?this.date[1]:'',
            coupon_code:this.coupon_code
          })
          this.couponsData = data.data
          let {meta} = data
          this.pageConfig.total = meta.total
        },
        getSmeCouponList: async (params = {}) => {
          // status
          // 1-current 2-upcoming 3-past
          const { data } = await getSmeCouponList({
            start_time:this.date?this.date[0]:'',
            end_time:this.date?this.date[1]:'',
            coupon_code:this.coupon_code
          })
          this.couponsData = data
          // let {meta} = data
          // this.pageConfig.total = meta.total
        },
        orderAdvert: async params => {
          const { data } = await orderAdvert(params)
          this.network().getAdvertList({
            hideLoading: true
          })
        },
        getAlipayList: async() => {
          const {data} = await getAlipayList({
            page: this.pageConfig.currentPage,
            size: this.pageConfig.size,
            type: 1,
            start_time:this.date?this.date[0]:'',
            end_time:this.date?this.date[1]:'',
            coupon_code:this.coupon_code
          })
          this.couponsData = data.data
          let {meta} = data
          this.pageConfig.total = meta.total
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.news-container {
  .margint-left{
    margin-left: 30px;
  }
  .long-title{
    text-overflow: ellipsis;
    word-break: break-word;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .content-container {
    position: relative;
    .el-table {
      margin-top: 15px;
      border:1px solid #E1E4E8;
      border-radius: 4px;
      ::v-deep .headerClass{
        background:#F6F8FA;
        th{
          background:#F6F8FA;
          .cell{
            padding: 16px;
            font-size: 14px;
            color: #24292E;
          }
        }
      }
    }

    .btn-list {
      text-align: center;
      span {
        margin-right: 10px;
      }
    }
    .filter-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .filter-list {
        display: flex;
        .el-select {
          margin-right: 15px;
          width: 130px;
        }
      }
    }
  }
  .dialog-container {
    padding: 15px;
  }
  .ic-order {
    .svg-inline--fa {
      color: #91939A;
      font-size: 12px;
    }
  }
  .img-banner {
    width: 150px;
  }
  ::v-deep .flex-algin{
    display: flex;
    flex-direction: column;
    justify-content:space-between ;
    p{
      height: 24px;
    }
  }
  .el-table{
    p:first-child{
      color: #24292E;
      font-size: 14px;
      font-weight: 500;
    }
  }
}
</style>
